import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Monitor, X } from "lucide-react";

const KEY = "af-desktop-hint-dismissed";

export const DesktopHint = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    if (isMobile && !sessionStorage.getItem(KEY)) setShow(true);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(KEY, "1");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="desktop-hint"
          className="fixed inset-x-3 top-[72px] z-[60] md:hidden"
          initial={{ opacity: 0, y: -16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -16 }}
          transition={{ type: "spring", stiffness: 260, damping: 26 }}
        >
          <div className="flex items-center gap-3 rounded-2xl border border-[rgba(212,168,77,.35)] bg-[rgba(7,20,22,.92)] backdrop-blur-md px-4 py-3.5 shadow-[0_20px_60px_rgba(0,0,0,.5)]">
            <span className="grid place-items-center w-9 h-9 rounded-full bg-[rgba(212,168,77,.14)] text-[var(--gold)] flex-none">
              <Monitor size={17} />
            </span>
            <p className="m-0 flex-1 text-[12.5px] leading-snug text-[rgba(244,241,234,.82)]">
              For the full experience, this site is <strong className="text-[var(--gold-2)] font-semibold">best viewed on desktop</strong>.
            </p>
            <button
              type="button"
              data-testid="desktop-hint-close"
              aria-label="Dismiss"
              onClick={dismiss}
              className="grid place-items-center w-8 h-8 rounded-full text-[rgba(244,241,234,.6)] hover:text-[var(--gold-2)] transition-colors flex-none"
            >
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
